import { PAYMENT_ACCOUNT_KEYS, PAYMENT_ACCOUNT_LABELS } from '@metycle/shared';
import type { UseFormRegisterReturn } from 'react-hook-form';

import { Select } from '@/components/ui/select';

import { FieldShell } from './form-helpers';

// Receiving bank account for the invoice PDF's payment block (sell side only,
// Launchpad parity). "Auto" keeps the backend's currency/country routing.
export function BankAccountField({
  registration,
  disabled,
}: {
  readonly registration: UseFormRegisterReturn;
  readonly disabled: boolean;
}) {
  return (
    <FieldShell id="payment_account_key" label="Bank Account" error={undefined}>
      <Select
        id="payment_account_key"
        disabled={disabled}
        data-testid="bank-account-select"
        {...registration}
      >
        <option value="auto">Auto (based on currency/country)</option>
        {PAYMENT_ACCOUNT_KEYS.map((key) => (
          <option key={key} value={key}>
            {PAYMENT_ACCOUNT_LABELS[key]}
          </option>
        ))}
      </Select>
    </FieldShell>
  );
}
